import { combineReducers } from 'redux';
import { authReducer } from './authReducer';
import { pricesReducer, balanceReducer, dataTableReducer } from './dataReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  dataTable: dataTableReducer,
  prices: pricesReducer,
  balance: balanceReducer
});

export default rootReducer;
